import { AfterViewInit, Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { windowWhen } from 'rxjs/operators';
import { HttpService } from '../services/http.service';

@Component({
  selector: 'app-print-ticket',
  templateUrl: './print-ticket.component.html',
  styleUrls: ['./print-ticket.component.css']
})
export class PrintTicketComponent implements AfterViewInit {
public img: string = 'assets/images/default-ticket.png'; 
    public qrData: any = null;
  // Cantidad de copias del ticket por impresión
  copias = [1, 2, 3];
  constructor(private router: Router, private route: ActivatedRoute, private dataService: HttpService) { }
  id: String;
  data: any = [];
  ngAfterViewInit(): void {
    this.route.queryParams.subscribe(
      params => {
        this.id = params['id'];
        console.log(this.id);
        this.dataService.GetTicket(this.id).subscribe(async result => {
          if (result['hasError']) {

          } else {
            console.log(result);
            this.data = result['result']['data']['table0'];
             this.qrData = this.urlValidacion(this.data[0].token);
            await this.delay(100);
            if (this.data.length > 0) {
              window.print();
            }

          }

        });
      }
    )
  }

  // Dirección completa de la página de validación, usando el dominio donde está publicada la app
  urlValidacion(id: String): string {
    const ruta = this.router.serializeUrl(
      this.router.createUrlTree(['/validar-ticket'], { queryParams: { id: id } })
    );
    return window.location.origin + ruta;
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  fnImprimir(){
    window.print();
  }
  fnRegresar() {
    this.router.navigate(['/home']);


  }

}
